import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=a7715396&scoped=true"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=a7715396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7715396",
  null
  
)

export default component.exports